import { Box, Skeleton } from "@mui/material";

export const CompactChallengeSkeleton = () => (
  <Box
    px={2}
    minHeight={40}
    borderLeft={8}
    display="flex"
    borderRadius={2}
    alignItems="center"
    bgcolor="background.paper"
    boxShadow="0px 1px 4px 0px rgba(0, 0, 0, 0.15)"
    sx={{ borderLeftColor: "grey.200" }}
  >
    <Box mr={2} display="flex" alignItems="center" justifyContent="center">
      <Skeleton variant="circular" width={24} height={24} />
    </Box>
    <Box flex={1} mr={2}>
      <Skeleton variant="text" width="80%" height={20} />
    </Box>
    <Box textAlign="right">
      <Skeleton variant="text" width={60} height={16} />
    </Box>
  </Box>
);
